import { useUploadTellescopeFile } from "@tellescope/tanstack-query";
import { ImageUploadField, type ImageUploadFieldProps } from "@tellescope/ui";

const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/gif"];
const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;

export interface BookingPageImageFieldProps
  extends Pick<
    ImageUploadFieldProps,
    "orientation" | "uploadLabel" | "replaceLabel" | "uploadingLabel" | "removeLabel" | "fullWidth" | "labelClassName"
  > {
  id: string;
  label: string;
  value: string;
  onValueChange: (url: string) => void;
}

export const BookingPageImageField = ({ id, label, value, onValueChange, ...rest }: BookingPageImageFieldProps) => {
  const { uploadFileAsync, progress } = useUploadTellescopeFile({
    returnPublicURL: true,
    allowedFileTypes: ALLOWED_IMAGE_TYPES,
    maxFileSize: MAX_IMAGE_SIZE_BYTES,
  });

  const handleUpload = async (file: File) => {
    const { publicURL } = await uploadFileAsync({ name: file.name, size: file.size, type: file.type }, file);
    if (!publicURL) {
      throw new Error("Upload did not return a public URL");
    }
    return publicURL;
  };

  return (
    <ImageUploadField
      id={id}
      label={label}
      value={value}
      onChange={onValueChange}
      onUpload={handleUpload}
      progress={progress}
      fullWidth
      {...rest}
    />
  );
};
